import { SvgIcon, useTheme } from "@mui/material";

export const CheckboxIcon = () => {
  const theme = useTheme();

  return (
    <SvgIcon
      fontSize="small"
      sx={{
        ".icon-background": {
          fill: theme.palette.backgroundColor.component,
        },
        ".icon-border": {
          stroke: theme.palette.neutral.main,
        },
      }}
    >
      <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          className="icon-background"
          height="15"
          rx="3.5"
          width="15"
          x="0.5"
          y="0.5"
        />
        <rect
          className="icon-border"
          height="15"
          rx="3.5"
          width="15"
          x="0.5"
          y="0.5"
        />
      </svg>
    </SvgIcon>
  );
};

export const CheckboxCheckedIcon = () => {
  const theme = useTheme();

  return (
    <SvgIcon
      fontSize="small"
      sx={{
        ".icon-background": {
          fill: theme.palette.secondary.main,
        },
        ".icon-border": {
          stroke: theme.palette.secondary.contrastText,
        },
        ".icon": {
          stroke: theme.palette.secondary.contrastText,
        },
      }}
    >
      <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          className="icon-background"
          height="15"
          rx="3.5"
          width="15"
          x="0.5"
          y="0.5"
        />
        <rect
          className="icon-border"
          height="15"
          rx="3.5"
          width="15"
          x="0.5"
          y="0.5"
        />
        <path
          className="icon"
          d="M12 5L6.5 10.5L4 8"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </svg>
    </SvgIcon>
  );
};
